<template>
  <v-dialog v-model="dialog" :overlay="false" scrollable max-width="600px">
    <v-card tile flat>
      <v-app-bar flat dark color="primary">
        <v-app-bar-nav-icon><v-icon>business</v-icon></v-app-bar-nav-icon>
        <v-toolbar-title>Add a new bank for {{ account.name }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="closeDialog" dark>
          <v-icon>close</v-icon>
        </v-btn>
      </v-app-bar>
      <v-card-text class="pa-0">
        <v-card flat tile class="ma-0 mb-5">
          <v-card-text class="pa-4">
            <v-card-title class="pa-0">Bank Details</v-card-title>

            <v-form lazy-validation>
              <v-container fluid grid-list-md class="pa-0">
                <v-layout wrap>
                  <v-flex xs12>
                    <v-layout wrap>
                      <v-flex xs6>
                        <v-text-field
                          label="Bank Name"
                          v-model="details.business.commercialName"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs6>
                        <v-text-field label="BBB ID" v-model="details.bbb_id" required></v-text-field>
                      </v-flex>
                      <v-flex xs6>
                        <v-text-field
                          label="Referral Confirmation Email"
                          v-model="details.referral_confirmation_email"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs6>
                        <v-text-field label="Parse Mathod" v-model="details.parse_method" required></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
            <v-btn color="accent" @click.native="register" :disabled="stepOneInvalid">Add Bank</v-btn>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import _ from 'lodash';

export default {
  name: 'new-bank',
  props: ['show', 'account'],
  data: () => ({
    details: {
      business: {
        commercialName: null,
        type: 'bank'
      },
      account_id: null,
      bbb_id: null,
      parse_method: null,
      referral_confirmation_email: null
    }
  }),
  computed: {
    stepOneInvalid: function() {
      return _.isNull(this.details.business.commercialName) || _.isNull(this.details.bbb_id);
    },
    dialog: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('update:show', value);
      }
    }
  },
  methods: {
    ...mapActions(['registerAccountBusiness']),
    clearRegistration() {
      this.details = {
        business: {
          commercialName: null,
          type: 'bank'
        },
        account_id: null,
        bbb_id: null,
        parse_method: null,
        referral_confirmation_email: null
      };
    },
    register() {
      this.details.account_id = this.account.id;
      this.registerAccountBusiness(this.details).then(this.closeDialog());
    },
    closeDialog() {
      this.clearRegistration();
      this.dialog = false;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  div.list__tile,
  .subheader {
    padding: 0 16px 0 0;
  }

  input,
  label {
    font-size: 14px;
  }
}

address {
  font-style: normal;
}
</style>
